const columns = {
  dashboard: [],
  home: [],
}

export default columns
